import React from 'react'

const SkinThemeContext = React.createContext({})

export const SkinThemeProvider = SkinThemeContext.Provider
export const SkinThemeConsumer = SkinThemeContext.Consumer
export default SkinThemeContext
